export const MCO_ROLES = ["SUPER_ADMIN", "OPERATIONS_MANAGER"];
export const MCO_ADMIN_ROLES = ["SUPER_ADMIN"];
export const MCO_ENABLED = true;

export const MCO_ROUTES = {
    dashboard: "/mco/dashboard",
    batches: "/mco/batches",
    assignments: "/mco/assignments",
    pendingAssignments: "/mco/pending-assignments",
    dailyTotals: "/mco/daily-totals",
    terminals: "/mco/terminals",
    mismatches: "/mco/mismatches",
    settings: "/mco/settings",
};
